const Notifications = {
  path: "",
  name: "",
  redirect: "/notification",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/notification",
      redirect: "/notification",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Notification",
      meta: {
        requiresAuth: true,
        activeUrl: "/notification",
        parent: "notification",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/notification/Index"),
          meta: {
            requiresAuth: true,
            activeUrl: "/notification",
            parent: "notification",

            lv: 2,
          },
        },
        {
          path: "details/:id",
          name: "Notification Detail",
          component: () => import("@/views/pages/notification/Details"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/notification",
            parent: "notification",
            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Notifications;
